<div class="county-autocomplete">
  <div class="input-wrapper">
    <input
      #countyInput
      type="text"
      class="form-control county-input autocomplete-v3-input"
      [id]="inputId"
      [name]="inputName"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [ngClass]="inputClass"
      [value]="inputValue"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      autocomplete="off"
      spellcheck="false"
    />

    @if (loading) {
      <div class="spinner"></div>
    }

    @if (inputValue && !loading && !disabled) {
      <button
        type="button"
        class="clear-btn"
        (click)="onClear()"
        aria-label="Clear">
        ×
      </button>
    }
  </div>

  @if (showDropdown && options.length) {
    <ul class="dropdown">
      @for (opt of options; track opt.placeId) {
        <li
          class="option"
          (mousedown)="onSelectOption(opt)">
          {{ opt.display }}
        </li>
      }
    </ul>
  }
</div>
